import { DEV_BASE_URL } from "../constants";
import api from './api';

export async function getCourseData(limit, courseId) {
    try {
        let url = DEV_BASE_URL + "get_course/?limit="+limit.toString() +"&course_id="+courseId;
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function getCourseCategory() {
    try {
        let url = DEV_BASE_URL + "get_course_categories/";
        const res = await api.get(url);
        return res['data']
    } catch (error) {
        console.error('There was an error fetching the data:', error);
        throw error;
    }
}

export async function addCourseToCart(courseData) {
    try {
        let url = DEV_BASE_URL + "add_to_cart/";
        let cartData = {
            "user_id": localStorage.getItem("userId"),
            "source": "web",
            "source_id": 1,
            "discount_perc": 0,
            "is_new_cart": true,
            "is_update_cart": false,
            "selected_payment_mode": "online",
            "stage": "addtocart",
            "coupon_code": null,
            "courses": [courseData],
        }

        const res = await api.post(url, cartData);
        return res['data'];

    } catch (error) {
        console.log('There was an error in add to cart:', error)
    }
}

export async function updateCart(courseData) {
    try {
        let url = DEV_BASE_URL + "add_to_cart/";
        let cartData = {
            "user_id": localStorage.getItem("userId"),
            "is_new_cart": false,
            "is_update_cart": true,
            "courses": [courseData],
        }

        const res = await api.post(url, cartData);
        return res['data'];
    } catch (error) {
        console.log('There was an error in add to cart:', error)
    }
}